module.exports = __webpack_public_path__ + "static/img/vip-look.948eafc.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/vip-look.png
// module id = 4vb+
// module chunks = 0